var BufferListBufferView = require('bufferlistbufferview');
var Keyboard = require('../../lib/keyboard.es6').default;

var BufferListServerLogView = BufferListBufferView.extend({
    getTemplate: function () {
        if (!BufferListServerLogView._structure) {
            var structure = BufferListBufferView.prototype.getTemplate.call(this);
            structure.prepend('<i class="spin">');
            var bufferOptions = this.renderBufferOptions();
            structure.prepend(bufferOptions);
            structure.prepend('<span class="drag" title="Drag">');

            structure.append('<i class="fa fa-globe">');
            structure.append('<i class="fa fa-shield" title="Secure connection">');
            structure.append('<i class="fa fa-slack" title="Slack Team">');
            structure.append('<i class="fa fa-exclamation ssl_verify_error_icon" title="Strict transport security error">');
            BufferListServerLogView._structure = structure;
        }
        return BufferListServerLogView._structure.clone();
    },
    render: function () {
        BufferListBufferView.prototype.render.call(this);

        this.bindBufferOptions();
        
        this.listenTo(this.model.connection, 'change:name', this.renderLinkText);
        this.listenTo(this.model.connection, 'urlChange', this.renderLinkUrl);

        return this;
    },
    renderBufferOptions: function () {
        return $('<button class="bufferOptions fa fa-cog">').attr({
            'title': "Options",
            'aria-label': "Options",
            'aria-expanded': false,
            'aria-controls': 'serverLogContextMenu',
            'aria-haspopup': 'true'
        });
    },
    bindBufferOptions: function () {
        var bufferOptions = this.link.find('.bufferOptions');  
        // Can't bind these on render, need to wait till they're added to the dom
        bufferOptions.on('keypress buttonClick mouseup', _.bind(function (e) {
            // Prevent buffer select
            e.stopPropagation();
        }, this));
        bufferOptions.on('click', _.bind(function (e) {
            // Prevent buffer select
            e.stopPropagation();
            this.model.session.trigger('bufferOptions', bufferOptions, this.model, e);
        }, this));
    },
    renderLinkUrl: function () {
        this.link.attr('href', this.model.connection.url());
        return this;
    },
    renderLinkText: function () {
        this.link.attr('title', this.model.connection.getName());
        this.setLinkLabelHtml(this.formatter.render(this.model.connection.getName()));
        return this;
    }
});


module.exports = BufferListServerLogView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/bufferlistserverlogview.js
// module id = 5hW5
// module chunks = 1